export const siteInfo = {
  name: "爆料51",
  fullName: "爆料51匿名通道",
  slogan: "匿名通道 · 隐私保护 · 保密机制",
  shortDesc: "全程保护隐私，采用保密机制处理每一条信息。",
  email: "contact@baoliao51.example.com",
  replyWindow: "3 个工作日",
  foundedYear: "2019",
};

export const navLinks = [
  { label: "首页", to: "/" },
  { label: "爆料指南", to: "/guide" },
  { label: "匿名投稿", to: "/submit" },
  { label: "常见问题", to: "/faq" },
  { label: "关于我们", to: "/about" },
];

export const footerCategories = [
  "职场与用工乱象",
  "消费与合同纠纷",
  "公共安全与隐患",
  "财务与商业道德",
  "环境与资源问题",
  "公共服务与流程",
];

export const footerLinks = [
  { label: "爆料指南", to: "/guide" },
  { label: "匿名投稿", to: "/submit" },
  { label: "常见问题", to: "/faq" },
  { label: "关于我们", to: "/about" },
];